import React, { useState } from 'react';
import { FaRegEyeSlash } from 'react-icons/fa';
import { IoEyeOutline } from 'react-icons/io5';
import { DNA, Oval, Triangle } from 'react-loader-spinner';
import { Link, useNavigate } from 'react-router-dom';
// import { api_url, auth_api_url } from '../config';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import api from '../utils/Api';
import { api_url } from '../utils/Config';
import { setAuthData } from '../redux/AuthSlice';
// import { setAuthData } from '../Redux/AuthSlice';

const LoginForm = () => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [passwordState, setPasswordState] = useState('')
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()

    const handlePasswordToggle = (e) => {
        e.preventDefault();
        setPasswordState(!passwordState);
    };
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        const loginForm = {
            email,
            password,
            type:'web'
        };
        try {
            setLoading(true);
            const response = await axios.post(`${api_url}/login`, loginForm, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            toast.success('Login Successful');
            dispatch(setAuthData(response.data));
            navigate('/dashboard')
        } catch (error) {
            toast.error(error?.response?.data?.error);
        } finally {
            setLoading(false);
        }
    };



    return (
        <div className='w-screen sm:max-w-md mx-auto'>


            <form className='flex flex-col gap-4 m-6' >
                <div className=' '>
                    <p className='text-2xl'>Welcome Admin!</p>
                    <p className='text-xs'>Sign In</p>
                </div>
                <div>
                    <label
                        htmlFor='email'
                        className='block mb-2 text-sm font-medium font-lufga text-gray-900 '
                    >
                        Email
                    </label>
                    <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type='email'
                        name='email'
                        id='email'
                        className='bg-gray-50 border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none  block w-full p-2.5 '
                        placeholder='admin@dev.com'
                        required
                    />
                </div>
                <div>
                    <label
                        htmlFor='password'
                        className='block mb-2 text-sm font-medium font-lufga text-gray-900 '
                    >
                        Password
                    </label>
                    <div className='flex justify-between items-center bg-gray-50 border text-xs border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600  w-full p-2.5 '>
                        <input
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            type={passwordState ? 'text' : 'password'}
                            name='password'
                            placeholder='••••••••'
                            className='bg-gray-50 focus:outline-none w-full'
                            required
                        />
                        {passwordState ? (
                            <IoEyeOutline size={20} onClick={handlePasswordToggle} />
                        ) : (
                            <FaRegEyeSlash size={20} onClick={handlePasswordToggle} />
                        )}
                    </div>
                </div>
                <div className='flex justify-end'>
                    <Link to='/forgot-password'>
                        <p className='hover:underline font-lufga cursor-pointer text-xs text-blue-800'>Forgot Password?</p>
                    </Link>
                </div>
                {error && (
                    <div>
                        <p className="bg-red-300 rounded-md font-lufga shadow-md px-2 py-1 text-xs">
                            {typeof error === 'string' ? error : (
                                Object.keys(error).map((key) => (
                                    Array.isArray(error[key]) ? error[key][0] : error[key]
                                ))
                            )}
                        </p>
                    </div>
                )}

                <div className='flex sm:justify-end'>
                    <button
                        disabled={loading}
                        onClick={handleLogin}
                        className='w-full sm:w-fit font-lufga text-white bg-[#1330C5] hover:opacity-90 focus:outline-none rounded-md shadow-md text-base px-4 py-2 sm:px-10 sm:py-2 text-center'
                    >
                        {loading ? (
                            <div className=" flex justify-center items-center">
                                <Oval
                                    visible={true}
                                    height="20"
                                    width="20"
                                    color="#ffff"
                                    ariaLabel="oval-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                />
                            </div>
                        ) : 'Sign In'}
                    </button>
                </div>

                {/* {loading && (<div className="flex justify-center items-center w-full h-full  backdrop-blur-sm absolute top-0 left-0">
                    <Triangle
                        visible={true}
                        height="80"
                        width="80"
                        color="#1330C5"
                        ariaLabel="triangle-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                </div>)} */}

            </form>

        </div>

    );
}

export default LoginForm;
